import { render, staticRenderFns } from "./QuoteProjectSizeDisplay.vue?vue&type=template&id=3edc6f9a&"
import script from "./QuoteProjectSizeDisplay.vue?vue&type=script&lang=ts&"
export * from "./QuoteProjectSizeDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports